import {
    GET_MERCHANT_PAYMENT_FILE_LIST_SUCCESS,
    GET_MERCHANT_PAYMENT_DETAIL_LIST_SUCCESS,
    GET_MERCHANT_PAYMENT_FILE_SEARCH_SUCCESS,
    MERCHANT_PAYMENT_FILE_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [],
    detailRecordList: [],
    error: {}
}

const merchantPaymentFile = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_MERCHANT_PAYMENT_FILE_LIST_SUCCESS:
        case GET_MERCHANT_PAYMENT_FILE_SEARCH_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }
        case GET_MERCHANT_PAYMENT_DETAIL_LIST_SUCCESS:
                return {
                    ...state,
                    detailRecordList: action.payload,
                }
        case MERCHANT_PAYMENT_FILE_API_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:
            return state
    }
}

export default merchantPaymentFile